module.exports = __webpack_public_path__ + "static/media/cryptopia.fbfbce57.svg";